import { observer } from "mobx-react-lite";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../helpers";
import { FTPBreadCrumbs } from "../../components-new/BreadCrumbs";
import { PRINT_MEDIA_ROUTES } from "./print-media-settings";

const crumbs = [{ name: "Media Dashboard", href: "#", current: true }];

export const MediaDashboard = observer(() => {
    const rootStore = useStore();
    const navigate = useNavigate();

    const printMediaAdminSections = [
        {
            icon: "fa-solid fa-search text-indigo-600",
            name: "Manage Search Terms",
            action: () => navigate(PRINT_MEDIA_ROUTES.manageSearchTerms),
        },
        {
            icon: "far fa-newspaper text-yellow-600",
            name: "Print Media Reports",
            action: () => navigate(PRINT_MEDIA_ROUTES.reports),
        },
    ];

    const printMediaSections = rootStore.userStore.isRoot() ? [...printMediaAdminSections] : [];

    return (
        <>
            <FTPBreadCrumbs crumbs={crumbs} />
            <div className="p-4">
                <div className="mt-2 text-base font-bold uppercase text-gray-800">Print Media</div>
                <div className="mt-2 grid flex-col grid-cols-1 flex-wrap items-stretch justify-start md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4">
                    {printMediaSections.map((section) => (
                        <div key={section.name} className="cursor-pointer p-4" onClick={section.action}>
                            <div className="flex flex-row flex-nowrap items-center rounded-lg bg-white p-4 shadow-md hover:shadow-xl">
                                <div className="flex h-20 w-20 items-center justify-center rounded-full bg-blue-200 text-4xl">
                                    <i className={section.icon} />
                                </div>
                                <div className="ml-4 text-lg font-bold">{section.name}</div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-10 text-base font-bold uppercase text-gray-800">Digital Media</div>
                <div className="mt-2 text-base italic text-gray-800">Coming soon...</div>
                <div className="mt-10 text-base font-bold uppercase text-gray-800">Social Media</div>
                <div className="mt-2 text-base italic text-gray-800">Coming soon...</div>
            </div>
        </>
    );
});
